export default __webpack_public_path__ + "static/5-01183ae214331e7b21a41df9a8b5b534.webp";